// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VCalendar from "v-calendar";
import { setAuthToken } from "@/services/api";
import { MotionPlugin } from "@vueuse/motion";
import timeSyncService from "@/services/timeSyncService";

async function initializeApp() {
  await timeSyncService.initialize();

  const token = sessionStorage.getItem("token");
  if (token) {
    setAuthToken(token); // ← ここで必ず axios.defaults.headers.Authorization を設定
  }

  // v-calendar をプラグインとして登録（オプションでテーマや設定も可能）
  const app = createApp(App);

  // Make the time service available globally
  app.config.globalProperties.$now = () => timeSyncService.now();

  app.use(router);
  app.use(MotionPlugin);
  app.use(VCalendar, {
    componentPrefix: "v", // <v-calendar> として使用可能
  });
  app.mount("#app");
}

initializeApp();
